import script from "./ServicesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesSection.vue?vue&type=script&setup=true&lang=js"

import "./ServicesSection.vue?vue&type=style&index=0&id=27d80c22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d80c22"]])

export default __exports__